<template>
    <div class="product">
      <div class="item" v-for="(item, index) in products" :key="item.goodsId">
      <a href="javascript:;" @click="onProductItem(item)">
        <i v-if="index<20">{{index+1}}</i>
        <div
          class="image"
          :style="'background:url('+item.originalImg+'?x-oss-process=style/suhuishou200) no-repeat;background-size: 100%;'"
        ></div>
        <div class="con">
          <p class="name">{{item.goodsName}}</p>
          <p class="price">
            回收均价 :
            <span>¥{{item.shopPrice}}</span>
          </p>
        </div>
      </a>
      </div>
    </div>
</template>
<style scoped>
.product {
  width: 2.95rem;
  background: #f8f8f8;
  margin-left: 0.8rem;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
}
.product .item {
  height: 0.9rem;
  
  padding: 0.2rem 0 0 0.4rem;
  border-bottom: solid #efefef 1px;
  position: relative;
}
.product .item a{
  display: flex;
}
.product .item .image {
  width: 0.6rem;
  height: 0.6rem;
  background-size: 100% !important;
}
.product .item .con {
  margin: 0 0 0 0.1rem;
}
.product .item .con .name {
  margin-top: 0.05rem;
}
.product .item .con .price {
  margin-top: 0.1rem;
  font-size: 0.12rem;
  color: #666;
}
.product .item .con .price span {
  color: #ef1411;
}
.product .item i {
  display: inline-block;
  position: absolute;
  top: 0.2rem;
  left: 0.1rem;
  background: #ccc;
  color: rgb(255, 255, 255);
  display: inline-block;
  width: 20px;
  font: 12px "微软雅黑";
  text-align: center;
  padding: 2px 0;
}
.product .item i:after {
  border-top: 6px solid transparent;
  border-left: 5px solid #ccc;
  position: absolute;
  top: 14px;
  right: -4px;
  content: " ";
}
.product .item:nth-child(1) i {
  background-color: #fd6132;
}
.product .item:nth-child(1) i:after {
  border-left-color: #fd6132;
}
.product .item:nth-child(2) i {
  background-color: #ff7a06;
}
.product .item:nth-child(2) i:after {
  border-left-color: #ff7a06;
}
.product .item:nth-child(3) i {
  background-color: #4fabef;
}
.product .item:nth-child(3) i:after {
  border-left-color: #4fabef;
}
</style>
<script>
export default {
  props: ["products"],
  data() {
    return {
      allLoaded: false
    };
  },
  components: {},
  mounted: function() {},
  methods: {
    loadMore() {
      this.$emit("getMoreProductList");
    },
    onProductItem(item){
      window._hmt.push(['_trackEvent', '分类列表右侧', '点击', item.goodsName,item.goodsId]); 
      this.$router.push({ name: 'mobileOldProductId',params:{id:item.goodsId} })
    }
  }
};
</script>